<template>
  <v-row align="center">
    <v-app-bar :color="account.color_background" app elevate-on-scroll>
      <v-sheet class="overflow-hidden mt-14" width="100" rounded outlined>
        <v-responsive class="align-center" :aspect-ratio="1/1">
          <v-sheet class="px-1" color="white" width="100">
            <v-img :src="account.logo" width="100%" />
          </v-sheet>
        </v-responsive>
      </v-sheet>
      <v-spacer />
      <v-skeleton-loader width="360" class="v-app-bar-skeleton" boilerplate type="table-tfoot" />
    </v-app-bar>

    <v-col cols="4" class="py-14 px-5">
      <span class="d-block mb-4 body-1 text--secondary font-weight-medium">Este es tu Signup Form, ¡pruébalo!</span>
      <span class="d-block mb-2">Imagina que eres un cliente que se quiere suscribir a tu plan.</span>
      <span class="d-block mb-2">Completa la información de facturación y agrega una tarjeta para suscribirte.</span>
    </v-col>

    <v-col cols="8">
      <v-sheet class="overflow-hidden" outlined rounded>
        <div id="piriod-widget"></div>
      </v-sheet>
    </v-col>

    <v-bottom-sheet v-model="displayBottomSheet" inset persistent>
      <v-sheet class="py-8 text-center" height="200px">
        <span class="d-block body-1 text--secondary font-weight-medium">¡Haz creado una suscripción tal como lo haría tu cliente!</span>
        <v-btn class="mt-8" color="primary" @click="done">Terminar</v-btn>
      </v-sheet>
    </v-bottom-sheet>
  </v-row>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    displayBottomSheet: false
  }),
  mounted () {
    const e = document.getElementById('piriod-widget')
    const i = document.createElement('iframe')

    i.src = `${this.$JS_BASE}/signup_forms/${this.$route.params.id}`
    i.id = 'piriod-widget'
    i.width = '100%'
    i.height = '640'
    i.style = 'border:none'

    e.appendChild(i)

    window.addEventListener('message', this.onComplete)
  },
  methods: {
    onComplete (e) {
      if (e.data.event === 'piriod_signup_form_subscription' && e.origin === this.$JS_BASE) {
        if (e.data.status === 'succeeded') {
          this.displayBottomSheet = true
          setTimeout(() => {
            this.done()
          }, 10000)
        }
      }
    },
    done () {
      window.close()
      window.open(`${this.$CLIENT_BASE}/subscriptions`)
    }
  }
}
</script>
<style>
.theme--light.v-skeleton-loader.v-app-bar-skeleton .v-skeleton-loader__bone {
  background: transparent !important;
}
.theme--light.v-skeleton-loader.v-app-bar-skeleton .v-skeleton-loader__bone .v-skeleton-loader__bone {
  background: rgba(0, 0, 0, 0.3) !important;
}
</style>